module.exports = __webpack_public_path__ + "img/phone.41d0367a.png";